import { FETCH_WITH_TOKEN } from '@services/react-query/config'
import { GET_REFERRAL_USER_URL } from '@services/react-query/urls/referrals'
import { useQuery } from '@tanstack/react-query'
import { ReferralUser } from '@type/referrals'

const useGetReferralUser = (userId?: string) => {
  const { ...data } = useQuery<ReferralUser>({
    queryKey: ['referral-user'],
    queryFn: async () => {
      if (!userId) return null
      try {
        return await FETCH_WITH_TOKEN(GET_REFERRAL_USER_URL(userId))
      } catch (err: any) {
        if (err.response?.status === 404) return null // return null instead of throwing
        throw err
      }
    },
    enabled: !!userId && typeof window !== 'undefined',
    retry: false,
  })
  return data
}

export default useGetReferralUser
